import { render } from "./Lire.vue?vue&type=template&id=b107dfc6&scoped=true"
import script from "./Lire.vue?vue&type=script&lang=js"
export * from "./Lire.vue?vue&type=script&lang=js"

import "./Lire.vue?vue&type=style&index=0&id=b107dfc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b107dfc6"]])

export default __exports__